/**
 * pickup-instructions slug — create-form input schema and Mantine form helpers.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 */
import { z } from "zod";

import {
  type PickupInstructionsDocumentInput,
  PickupInstructionsDocumentInputSchema,
  PickupInstructionsLineItemInputSchema,
} from "~/shared/documents/schemas/pickup-instructions-input.schema";

export {
  type PickupInstructionsDocumentInput,
  PickupInstructionsDocumentInputSchema,
  PickupInstructionsLineItemInputSchema,
} from "~/shared/documents/schemas/pickup-instructions-input.schema";

const PickupInstructionsDocumentFieldsSchema = PickupInstructionsDocumentInputSchema.omit({ orderId: true }).extend({
  lineItems: z.array(PickupInstructionsLineItemInputSchema),
});

/** Mantine shell before prefill loads; lineItems stay empty until server prefill returns. */
export const pickupInstructionsDocumentFormInitialValues = (): Omit<PickupInstructionsDocumentInput, "orderId"> =>
  PickupInstructionsDocumentFieldsSchema.parse({ lineItems: [], selectedRateCosts: [] });
